const styles = {
  linkView: {
    marginRight: 16,
    width: "20%",
  },
  button: {
    width: "100%",
  },
};

export default styles;
